<template>
  <div class="month_wrap">
    <div class="month_item">
      <p class="month before_border ab c5a" v-if="currentOrderMonth != 0"><span class="month_number rb">{{ currentOrderMonth }}</span>月</p>
      <p class="month" style="border-bottom: none;" v-else></p>
      <div class="count_wrap">
        <span class="count ab c5a">数量</span>
        <div class="bottom_arrow select_count">
          <select name="buy_count" id="" class="c5a rb" v-model="itemCount1">
            <option v-for="n of getMaxCount(true) + 1" :value="n - 1">{{ n - 1 }}</option>
          </select>
        </div>
      </div>
    </div>

    <div v-if="nextOrderMonth != 0" class="month_item">
      <p class="month before_border ab c5a"><span class="month_number rb">{{ nextOrderMonth }}</span>月</p>
      <div class="count_wrap">
        <span class="count ab c5a">数量</span>
        <div class="bottom_arrow select_count">
          <select name="buy_count" id="" class="c5a rb" v-model="itemCount2">
            <option v-for="n of getMaxCount(false) + 1" :value="n - 1">{{ n - 1 }}</option>
          </select>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Config from '@/config/config'
import ProductFunction from '@/model/n-selection/selectProducts'


export default {
  props: ['productId', 'genreId'],
  data() {
    return {
      itemCount1: 0,
      itemCount2: 0,
      currentOrderMonth: 0,
      nextOrderMonth: 0,

    }
  },
  methods: {
    getMaxCount(isCurrent) {
      const indexList = ProductFunction.productIndex(this.productsList, this.productId, this.genreId);
      if(indexList == undefined) return 0;
      return this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.maxCount;
    },
    getMonthData() {
      const indexList = ProductFunction.productIndex(this.productsList, this.productId, this.genreId);
      if(indexList == undefined) return;
      this.currentOrderMonth = this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].currentOrderMonth
      this.nextOrderMonth = this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].nextOrderMonth
    },
    initialized() {
      this.getMonthData();
      const index = this.nselectionOrderList.findIndex(({productId}) => productId === this.productId);
      for (let i = 0; i < this.nselectionOrderList[index].purchaseOrderItemList.length; i++) {
        if(i == 0) {
          this.itemCount1 = this.nselectionOrderList[index].purchaseOrderItemList[i].orderCount;
        }
        if(i == 1) {
          this.itemCount2 = this.nselectionOrderList[index].purchaseOrderItemList[i].orderCount;
        }
      }
    },
    updateOrderitem() {
      const index = this.nselectionOrderList.findIndex(({productId}) => productId === this.productId);
      console.log(index);
      if(this.itemCount1 == 0 && this.itemCount2 == 0) {
        this.$store.dispatch('nselection/deleteProduct', { deleteIndex: index });
        this.$store.dispatch('nselection/calcCartCount', { status: 'delete' });
        return;
      }
      let point = ProductFunction.calcPoint(this.productsList, this.productId, this.genreId, this.itemCount1, this.itemCount2);
      this.$store.dispatch('nselection/calcTotalPoint', { point: point, reset: false });

      const data = ProductFunction.updatePurchaseOrderItemList(this.nselectionOrderList[index], this.currentMonth, this.itemCount1, this.itemCount2);
      this.$store.commit('nselection/setNselectionOrderList', data);
    },
  },
  computed: mapGetters(
    'nselection', ['currentMonth', 'productsList', 'nselectionOrderList', 'cartIsOpen'],
  ),
  watch: {
    nselectionOrderList() {
      this.initialized();
    },
    cartIsOpen() {
      this.initialized();
    },
    itemCount1(newVal, oldVal) {
      let point = ProductFunction.calcPoint(this.productsList, this.productId, this.genreId, oldVal, this.itemCount2);
      this.$store.dispatch('nselection/calcTotalPoint', { point: -point, reset: false });
      this.updateOrderitem();
    },
    itemCount2(newVal, oldVal) {
      let point = ProductFunction.calcPoint(this.productsList, this.productId, this.genreId, this.itemCount1, oldVal);
      this.$store.dispatch('nselection/calcTotalPoint', { point: -point, reset: false });
      this.updateOrderitem();
    },
  },
  created() {
    // this.initialized();

  },
}
</script>

<style lang="css" scoped>

./* カートに商品がない場合 */
.cart_none {
  padding: 15px;
}
/* カート中身 */
.detail_wrap {
  overflow-y: inherit;
  padding-top: 74px;
}

.cart_wrap {
  border-bottom: 1px solid #c9c9c9;
  padding: 0 16px 10px;
}

.cart_title {
  font-size: 18px;
}

.price_wrap {
  color: #009FA9;
  text-align: right;
}

.price_sum {
  font-size: 28px;
}

.yen {
  font-size: 22px;
}

.cart_point {
  font-size: 18px;
}

.point {
  font-size: 14px;
}

.cart_pt {
  font-size: 14px;
}

.cart_tab input {
  display: none;
}

.cart_tab {
  border-bottom: 1px solid  #aaa;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cart_tab .tab {
  border: solid #AAAAAA;
  border-width: 1px 1px 0;
  border-radius: 12px 12px 0 0;
  background-color: #f4f4f4;
  color: #A3A3A3;
  font-size: 20px;
  padding: 9px 0 8px 16px;
  width: 49.9%;
}

.cart_tab .tab.isActive {
  background-color: #fff;
  color: #5a5a5a;
}

.other_bc {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 37px 16px 25px;
}
.bc_number {
  font-size: 20px;
}

.other_number--detail {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}
.other_bc--price {
  font-size: 26px;
}
.yen {
  font-size: 20px;
}
.btn_mini {
  margin: 16px 0 0;
}

.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 30px 15px 25px 30px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  width: 33%;
}

.select_image {
  /* margin: auto;
  width: 73%; */
}

.month_item {
  display: flex;
  margin-top: 16px;
}



.before_border::before {
  border-left: 4px solid #4FCCD4;
  bottom: 0;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}


.count_wrap {
  align-items: center;
  align-items: flex-end;
  display: flex;
  margin-left: 8px;

  width: 60%;

}

.select_item--title {
  font-size: 12px;
  margin-top: 12px;
}
.btn_delete {
  margin: 21px auto 0;
}

.select_contents {
  width: 59%;
}

.month_wrap {
  margin-top: 0;
}


.month {
  border-bottom: 1px solid #c9c9c9;
  font-size: 16px;
  letter-spacing: 1px;
  padding-left: 8px;
  position: relative;
  width: 40%;
}

.month::before {
  bottom: 2px;
  left: 0;
  width: 4px;
}

.month_number {
  font-size: 22px;
}


.count {
  font-size: 12px;
}

.select_count {
  border-bottom: 1px solid #5a5a5a;
  margin-left: 5px;
  /* width: 70%; */
  width: 63%;
}
.select_count:after {
  bottom: 6px;
  right: 0;
}
.select_count select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 20px;
  padding-left: 7px;
  /* padding-left: 5px; */
  /* padding-right: 10px; */
  /* text-align: center; */
  width: 100%;
}

.checkbox01 {
  display: flex;
  font-size: 14px;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 5px 0 5px 30px;
}

.checkbox01::before {
  left: 0;
}

.checkbox01::after {
  left: 5px;
}

.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.item_price {
  font-size: 26px;
}

.yen {
  font-size: 20px;
}

.item_point {
  font-size: 16px;
}

.point_text {
  font-size: 12px;
}

.select_sum {
  display: block;
  margin-top: 0;
  padding: 24px 15px;
}

.select_sum .item_price {
  margin-top: 0;
}

.select_sum .subtotal {
  font-size: 14px;
}

.btn_blue {
  margin-top: 32px;
}

/* {
  border-radius: 12px;
  bottom: 0;
  height: 78%;
  margin: auto;
  overflow-y: inherit;
  overflow: hidden;
  padding: 0;
  right: 0;
  top: -5%;
  width: 91%;
} */

.bg.open {
  top: 0;
}

.detail_wrap {
  max-height: 100%;
}


/* .scroll {
  max-height: 435px;
  overflow-y: scroll;
  padding-bottom: 60px;
} */

.buy_text {
  width: 70%;
}
.input_number {
  border: none;
  border-bottom: 1px solid #000;
  display: block;
  font-size: 26px;
  padding-right: 5px;
  text-align: right;
  width: 100%;
}

.no_month {
  justify-content: flex-end;
}
.no_month .month {
  display: none;

}
.no_month .count_wrap {
  margin-left: 0;
  align-items: flex-end;
  width: 65%;
}
.no_month .count {
  width: 30%;
}
.no_month .select_count {
  margin-right: 0;
  margin-left: 0;
  width: 70%;
}

</style>



// WEBPACK FOOTER //
// src/components/n-selection/parts/BuyTotalMonth.vue